import Reveal from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Demande & cotes",
    desc: "Vous décrivez l'objet souhaité — ou envoyez les photos et les cotes de la pièce à reproduire.",
  },
  {
    n: "02",
    title: "Devis sur mesure",
    desc: "Chiffrage détaillé transmis sous 48 h ouvrées, avec choix de la matière et délais.",
  },
  {
    n: "03",
    title: "Validation du projet",
    desc: "Après votre accord sur le devis : PDF avec rendu 3D et/ou plan pour valider le projet avant lancement.",
  },
  {
    n: "04",
    title: "Paiement & acompte",
    desc: "Après acceptation, règlement du devis. Pour les projets de plus de 50 €, un acompte de 30 % est demandé.",
  },
  {
    n: "05",
    title: "Fichiers & impression",
    desc: "Envoi du fichier .STL et, en option, impression de la pièce puis expédition.",
  },
];

export default function ProcessFlow() {
  return (
    <section id="process" className="scroll-mt-20 border-y border-black/5 bg-mist py-24 lg:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <Reveal>
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-accent">Notre process</span>
          <h2 className="mt-3 max-w-2xl font-display text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Cinq étapes, zéro surprise.
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-neutral-600 sm:text-base">
            Vous validez le projet avec un PDF (rendu 3D et/ou plan) avant tout lancement. Pour les
            projets de plus de 50 €, un acompte de 30 % est demandé après acceptation du devis — le
            solde est réglé avant la livraison des fichiers.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-[20px] border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.07} className="h-full">
              <div
                data-testid={`process-step-${s.n}`}
                className="flex h-full flex-col bg-white p-5 transition-colors duration-300 hover:bg-orange-50/60 sm:p-6"
              >
                <span className="font-mono text-3xl font-bold text-neutral-300 transition-colors duration-300">
                  {s.n}
                </span>
                <h3 className="mt-8 font-display text-sm font-bold tracking-tight text-ink sm:text-base">
                  {s.title}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-neutral-600">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
